module.exports = __webpack_public_path__ + "static/media/Entreprise-Construction-Projet-Immobilier-Vaud.54386f47.jpg";